module.exports = __webpack_public_path__ + "static/media/vertical-ellipsis.f4a34361.svg";